const VIEW_MENU_HIDDEN_CLASS = 'menu-hidden';

export const royale_viewSetupResponsive = () => {

  const responsive_trigger = 600;
  let $ = jQuery;
  let win = jQuery(window);
  let _body = jQuery('body');

  let ww = 0;
  let th = 0;
  let wide = 0;
  let menuWid = 220;
  let inter_calculateDims = 0;
  let content = jQuery('.royale--content');

  win.on('resize', window_resize);
  window_resize();

  $(document).on('click', '.hidemenu,.showmenu,.responsive-menu--toggle', handle_mouse);

  function onhidemenu() {
    _body.addClass(VIEW_MENU_HIDDEN_CLASS);
    _body.removeClass('menu-open');
    setTimeout(do_onhidemenu, 250);

    function do_onhidemenu() {
      $('.showmenu').css('left', 0);



    }
  }

  function onshowmenu() {
    $('.showmenu').css('left', -57);
    setTimeout(do_onshowmenu, 250);

    function do_onshowmenu() {
      _body.removeClass(VIEW_MENU_HIDDEN_CLASS);
      _body.addClass('menu-open');
    }

    setTimeout(do_onshowmenu2, 450);

    function do_onshowmenu2() {


    }
  }


  function handle_mouse(e) {
    var _t = $(this);


    if (_t.hasClass('responsive-menu--toggle')) {
      if (_body.hasClass(VIEW_MENU_HIDDEN_CLASS)) {

        onshowmenu();
      } else {

        onhidemenu();
      }
      return false;
    }

    if (_t.hasClass('hidemenu')) {
      onhidemenu();
    }
    if (_t.hasClass('showmenu')) {
      onshowmenu();
    }
  }

  function calculateDims() {


  }



  function window_resize(event) {
    if (typeof event !== "undefined") event.stopPropagation();
    ww = jQuery(window).width();
    th = jQuery(window).height();

    if (ww < responsive_trigger) {
      _body.addClass('responsive-mode');
    } else {
      _body.removeClass('responsive-mode');
      _body.removeClass(VIEW_MENU_HIDDEN_CLASS);


    }





    if (ww < 600) {
      onhidemenu();
    }


    clearTimeout(inter_calculateDims);
    inter_calculateDims = setTimeout(calculateDims, 150);


  }

}